module.exports = __webpack_public_path__ + "static/media/hindsightHero.8d27b694.jpg";